import React, { useState } from 'react';
import { FaEdit } from 'react-icons/fa';
import { useDispatch } from 'react-redux';

import { showModal } from 'legacy/actions/modalActions';

import { useGetMe } from 'legacy/user/hooks';

import FieldSkeleton from '../FieldSkeleton';

import UpdateEmailFlow from './UpdateEmailFlow';

const EmailSettings = () => {
  const dispatch = useDispatch();
  const { data: user, isFetching: isFetchingUser } = useGetMe();

  const [showUpdateEmailFlow, setShowUpdateEmailFlow] = useState(false);

  if (isFetchingUser) {
    return <FieldSkeleton />;
  }

  return (
    <>
      <div className="flex items-center py-1 px-[12px]">
        <div className="text-base text-gray-400">Email</div>
        <div
          className="ml-3 flex items-center mt-px text-sm text-primary-500 px-4 cursor-pointer"
          onClick={() => {
            if (!user?.email) {
              /**
               * NOTE: This is temporary while we migrate all users to the new auth mechanism.
               * We cannot show the edit email modal to users without an email, because they would more than likely not have a password as well.
               * This means they would become stuck on the second part of the update email flow once the user is prompted to enter their password.
               *
               * Once the auth migration is complete then this will never happen, since every user will have an email address and password.
               */
              dispatch(
                showModal('ALERT', {
                  type: 'info',
                  // TODO: Change this message when we add a migration page.
                  message:
                    'To add an email, refresh the page and update your account details when prompted.'
                })
              );

              return;
            }

            setShowUpdateEmailFlow(true);
          }}
        >
          {user?.email ? (
            <>
              {user.email} <FaEdit className="ml-2 mb-1" />
            </>
          ) : (
            <span className="mt-px">+ Add Email Address</span>
          )}
        </div>
      </div>

      {showUpdateEmailFlow && (
        <UpdateEmailFlow
          onClose={() => {
            setShowUpdateEmailFlow(false);
          }}
          onSuccess={() => {
            setShowUpdateEmailFlow(false);
          }}
        />
      )}
    </>
  );
};

export default EmailSettings;
